import { useEffect, useState } from "react";
import useQueries from "../useQueries";
import { getDate } from "@/shared/utils/getDate";
import { buildQuery } from "@/shared/utils/buildQuery";
import useData from "../useData";
import { API_URL } from "@/shared/utils/API_URL";

const formatDate = (date: any) => {
    const year = date?.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

const useMonthlyInvoices = () => {
    const queries = useQueries();
    const [dialog, setDialog] = useState({
        open: false,
        invoiceType: 'all_types'
    });
    const [appliedInvoiceType, setAppliedInvoiceType] = useState('all_types')
    const [date, setDate] = useState(() => {
        return sessionStorage.getItem('startDate') || formatDate(new Date());
    });
    const [enddate, setEndDate] = useState(() => {
        return sessionStorage.getItem('endDate') || formatDate(new Date);
    });

    useEffect(() => {
        sessionStorage.setItem('startDate', date);
    }, [date]);

    useEffect(() => {
        sessionStorage.setItem('endDate', enddate);
    }, [enddate]);


    const [viewTotals, setViewTotals] = useState(false);

    const q = queries
        ? buildQuery(queries?.monthlyInvoicesQuery,
            { fromDate: `${date} 00:00:00`, endDate: `${enddate} 23:59:59` }
        )
        : '';

    const { fetchedData, loading } = useData({
        apiUrl: API_URL,
        q: q,
        t: "sel",
        dependency: [q, date, enddate],
    });

    const invoices = fetchedData?.data?.result || [];
    const filteredInvoices = invoices.filter((invoice: any) => {

        if (appliedInvoiceType == 'all_types') return true;
        if (appliedInvoiceType == 'Sell') {
            return invoice?.invoicetype === 'Sell'
        }
        else if (appliedInvoiceType == 'Buy') {
            return invoice?.invoicetype === 'Buy'
        }
        else if (appliedInvoiceType == 'ReturnSell') {
            return invoice?.invoicetype === 'ReturnSell'
        }
        else if (appliedInvoiceType == 'ReturnBuy') {
            return invoice?.invoicetype === 'ReturnBuy'
        }
    });

    const handleQuickSelect = (type: string, dateType: string) => {


        let start = new Date();
        let end = new Date();
        let now = new Date();
        if (type == 'today') {
            start = new Date();
            end = new Date();
        }
        else if (type == 'yesterday') {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            start = yesterday;
            end = yesterday;
        }
        else if (type === 'current_month') {

            start = new Date(now.getFullYear(), now.getMonth(), 1);
            end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        }
        else if (type === 'last_month') {
            start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
            end = new Date(now.getFullYear(), now.getMonth(), 0);
        }

        setDate(formatDate(start));
        setEndDate(formatDate(end));
    }
    const totalsByType = filteredInvoices.reduce((acc: any, curr: any) => {
        const type = curr.invoicetype || t('unknown');
        const value = Number(curr.totvalue || 0);
        acc[type] = (acc[type] || 0) + value;
        return acc;
    }, {});
    const onCloseDialog = () => {
        setDialog((prev) => ({ ...prev, open: !dialog.open }))
    }

    return {
        handleQuickSelect,
        date,
        setDate,
        enddate,
        setEndDate,
        dialog,
        setDialog,
        totalsByType,
        onCloseDialog,
        viewTotals,
        setViewTotals,
        loading,
        filteredInvoices,
        q,
        setAppliedInvoiceType
    }
}

export default useMonthlyInvoices;